import { Badge } from '@/components/ui/Badge';
import { getCurrentUser } from '@/lib/auth';

export function AdminHeader() {
  const user = getCurrentUser();

  return (
    <header className="sticky top-0 z-10 bg-surface-elevated/95 dark:bg-surface-glass border-b border-border shadow-md dark:shadow-dark-md backdrop-blur-md flex-shrink-0">
      <div className="px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          {/* Left: Rainmaker Admin wordmark */}
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-text-primary tracking-tight">Rainmaker</span>
            <span className="text-sm font-semibold text-primary-600 tracking-widest uppercase">Admin</span>
          </div>

          {/* Right: ADMIN badge + user email */}
          <div className="flex items-center gap-3">
            <Badge variant="warning">ADMIN</Badge>
            {user?.email && (
              <span className="text-sm text-text-secondary hidden sm:block">
                {user.email}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
